<template>
  <div class="page">
    <SiteHero
      pageTitle="MEET MY TEAM"
      pageDescription="Our team of trainers for all of your fitness needs."
    />
  
    <div class="page-content">
      <div class="max-w-6xl mx-auto px-4 py-12">
        <div class="grid grid-cols-1 gap-8">
          <div v-for="(member, index) in teamData" :key="member.name">
            <TeamMember :member="member" :isLast="index === teamData.length - 1" />
          </div>
        </div>
      </div>
    </div>

    <SiteFooter />
  </div>
</template>
  
<script>
  import SiteFooter from '../components/Footer/SiteFooter.vue';
  import SiteHero from '../components/Hero/SiteHero.vue';
  import '../assets/styles/page.css';

  import TeamMember from '../components/Team/TeamMember.vue'
  import teamData from '../data/team.json'
  
  export default {
    name: 'TeamPage',
    components: {
      SiteFooter,
      SiteHero,
      TeamMember,
    },
    data() {
      return {
        teamData: teamData.team
      }
    }
  };
</script>
